<template>
  <v-form
    id="changePasswordForm"
    ref="changePasswordForm"
  >
    <v-card-text>
      <PolteqTextField
        v-model="password"
        field-id="passwordField"
        :label="i18n.t('fields.password')"
        :rules="[rules.required]"
        type="password"
        autocomplete="current-password"
        icon="mdi-lock-alert-outline"
      />
      <PolteqTextField
        v-model="newPassword"
        field-id="newPasswordField"
        :label="i18n.t('fields.newpassword')"
        :rules="[rules.password]"
        type="password"
        autocomplete="new-password"
        icon="mdi-lock-check-outline"
      />
      <PolteqTextField
        v-model="confirmPassword"
        field-id="confirmPasswordField"
        :label="i18n.t('fields.confirmpassword')"
        :rules="[rules.password_match(newPassword, confirmPassword)]"
        type="password"
        autocomplete="new-password"
        icon="mdi-lock-check-outline"
      />
    </v-card-text>
    <v-card-text style="text-align: end">
      <PolteqButton
        button-id="changePasswordButton"
        icon="mdi-lock-open-plus-outline"
        :button-text="i18n.t('buttons.changepassword')"
        @click="changePassword(password, newPassword)"
      />
    </v-card-text>
  </v-form>
</template>

<script lang="ts" src="./ChangePasswordForm.ts" />
